<div class="modal-sec d-flex flex-column spacing-32">
  <div
    class="modal-header p-0 d-flex flex-column align-items-center justify-content-center spacing-16">
    @if (modalDetail.showIcon) {
      <span class="modal-icon d-flex align-items-center justify-content-center">
        <app-ce-icon name="{{ modalDetail.topIcon }}" [svg_class]="['primary-50']"></app-ce-icon>
      </span>
    }
    <h1 class="h1-headers m-0 p-0 primary-100">
      {{ modalDetail.modalHeading }}
    </h1>
    <p class="m-0 p-0 h3-reg primary-60">
      {{ modalDetail.modalDescription }}
    </p>
  </div>
  <!-- <span class="cancel-btn cursor-pointer" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <app-ce-icon name="cancel" [svg_class]="['primary-50']"></app-ce-icon>
    </span> -->
  @if (modalDetail.showContent) {
    <div class="modal-body p-0 d-flex spacing-8 flex-column">
      @if (modalDetail.search) {
        <div
          class="w-100"
          app-search
          [placeholder]="'Search here...'"
          [active]="false"
          [SearchBtn]="false"
          [disabled]="false"
          [size]="'large'"></div>
      }
      <ng-content select="[paymentBlock]"></ng-content>
      @for (inputs of modalDetail.input; track inputs) {
        @if (modalDetail.showInput) {
          <app-inputs
            class="w-100"
            [options]="[
              { value: 'option1', label: 'Option 1' },
              { value: 'option2', label: 'Option 2' },
              { value: 'option3', label: 'Option 3' },
            ]"
            [type]="'text'"
            [name]="inputs.name"
            [form]="inputs.form"
            [tagLine]="''"
            [Label]="inputs.label"
            [active]="inputs.active"
            [placeholder]="inputs.placeholder"
            [dropdown]="inputs.dropdown"
            [options]="inputs.dropdownItems"
            [stepCounter]="false"
            [prefix]="inputs.prefix"
            [suffix]="false"
            [prefixBadge]="{
              icon: 'down_arrow',
              type: 'white',
              label: '%',
              rightIcon: false,
            }"
            [suffixBadge]="{
              icon: 'down_arrow',
              type: 'white',
              label: 'units',
              rightIcon: true,
            }"
            [prefixDropdown]="[{ name: '%' }, { name: '' }]"
            [suffixDropdown]="[{ name: 'units' }, { name: 'times' }]"
            [warn]="false"
            [state]="'default'"></app-inputs>
        }
      }
      @for (product of modalDetail.products; track product) {
        @if (modalDetail.showProduct) {
          <app-product-block
            class="w-100"
            [product]="product"
            [editAction]="false"
            [deleteAction]="false"
            (custon_click)="onActions($event)"></app-product-block>
        }
      }

      @if (modalDetail.alertBar) {
        <app-info
          class="w-100"
          [label]="modalDetail.alertContent"
          [Type]="modalDetail.alertColor"
          [icon]="false"
          [close]="false"
          [show_button]="false"
          [Size]="'large'"></app-info>
      }
      <div class="d-flex align-items-start flex-column spacing-12">
        <app-answers
          [flexDirection]="modalDetail.answerDirection"
          [numbring]="modalDetail.numbring"
          [input]="modalDetail.input"
          [width]="modalDetail.answerWidth"
          [answers]="modalDetail.answer"
          (selected)="selected($event)"></app-answers>
      </div>
      <ng-content></ng-content>
    </div>
  }

  @if (modalDetail.showBtns) {
    <div class="modal-footer p-0 d-flex align-items-center flex-column spacing-4 w-100 no-wrap">
      @if (modalDetail.primaryBtn.continueBtn) {
        <app-buttons
          class="w-100"
          [active]="modalDetail.primaryBtn.active"
          [success]="false"
          [alert]="modalDetail.primaryBtn.alert"
          [disabled]="modalDetail.primaryBtn.disabled"
          [label]="modalDetail.primaryBtn.label"
          [type]="'button'"
          [IconType]="'import'"
          [size]="'large'"
          [Type]="'withoutIcon'"
          (btnClick)="onActions('confirm')"></app-buttons>
      }
      @if (modalDetail.secondaryBtn.backBtn) {
        <app-secondary-btns
          class="w-100"
          [active]="false"
          (onClick)="onSecondary($event)"
          [disabled]="false"
          [label]="modalDetail.secondaryBtn.label"
          size="large"
          Type="withoutIcon"
          IconValue=""
          IconType="convert"></app-secondary-btns>
      }
    </div>
  }
</div>
